import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '@s-env/environment';

import { AuthService } from '@s-services/auth.service';
import { UiService } from '@s-services/ui.service';

import { HlmButton } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmInput } from '@spartan-ng/helm/input';
import { HlmLabel } from '@spartan-ng/helm/label';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
    FormsModule,
    RouterLink,
    HlmButton,
    ...HlmCardImports,
    HlmInput,
    HlmLabel,
]
})
export class LoginComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  devMode = !environment.production;

  constructor(private authService: AuthService,
    private router: Router,
    public uiService: UiService) { }

  ngOnInit() {
    this.authService.user.pipe(takeUntil(this.destroy$)).subscribe(user => {
      if (user) {
        this.router.navigate(['/']).then(() => {
          this.uiService.loading.next(false);
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /// Login ///
  onLoginWithPassword(form: NgForm): void {
    this.uiService.loading.next(true);
    this.authService.loginWithPassword(form.value).then(() => {
      this.loginSuccessful();
    }).catch(error => {
      this.uiService.showSimpleSnackbar(error, 'OK');
      this.uiService.loading.next(false);
    });
  }

  onGoogleLogin(): void {
    this.uiService.loading.next(true);
    this.authService.googleLogin().then(() => {
      this.loginSuccessful();
    }).catch(error => {
      this.uiService.showSimpleSnackbar(error, 'OK');
      this.uiService.loading.next(false);
    });
  }

  private loginSuccessful(): void {
    this.uiService.showSimpleSnackbar('Sie werden angemeldet...', '');
  }


  /// Helpers ///
  onForgotPassword(email: string): void {
    this.authService.forgotPassword(email).then(() => {
      this.uiService.showSimpleSnackbar('E-Mail wurde verschickt', '');
    }).catch(error => {
      this.uiService.showSimpleSnackbar(error, 'OK');
    });
  }
}
